const langDocumentFilesFilters = {
	search_with_document_name: {
		tag: 'document.files.filter.search_with_document_name',
		fr: 'Recherche par nom de document',
		en: 'Search with document name',
	},
	search_for_funds: {
		tag: 'document.files.filter.search_for_funds',
		fr: 'Liste des fonds / mandats',
		en: 'Funds list',
	},
	document_type: {
		tag: 'document.files.filter.document_type',
		fr: 'Type de document',
		en: 'Document type',
	},
	release_period: {
		tag: 'document.files.filter.release_period',
		fr: 'Période de publication',
		en: 'Release period',
	},
	release_period_1_month: {
		tag: 'document.files.filter.release_period_1_month',
		fr: '1 mois',
		en: 'Last month',
	},
	release_period_3_months: {
		tag: 'document.files.filter.release_period_3_months',
		fr: '3 mois',
		en: 'Last 3 months',
	},
	release_period_6_months: {
		tag: 'document.files.filter.release_period_6_months',
		fr: '6 mois',
		en: 'Last 6 months',
	},
	release_period_1_year: {
		tag: 'document.files.filter.release_period_1_year',
		fr: '1 an',
		en: 'Last year',
	},
	release_period_all: {
		tag: 'document.files.filter.release_period_all',
		fr: 'Toutes',
		en: 'All publications',
	},
	expertises: {
		tag: 'document.files.filter.expertises',
		fr: 'Expertises',
		en: 'Expertises',
	},
	fund_type: {
		tag: 'document.files.filter.fund_type',
		fr: 'Type de fonds',
		en: 'Funds type',
	},
	fund_vintage: {
		tag: 'document.files.filter.fund_vintage',
		fr: 'Millésime',
		en: 'Vintage',
	},
	document_format: {
		tag: 'document.files.filter.document_format',
		fr: 'PDF ou Excel',
		en: 'PDF or XLS',
	},
};

export default langDocumentFilesFilters;
